import React, { useState } from "react";
import ReactModal from "react-modal";
import Layout from "../components/layout";
import { Link } from "gatsby";

import "../scss/main.scss";
import AdvantagesSection from "../components/sections/advantages-section";

import { heroData } from "../datas/home/hero-section";
import { advantages } from "../datas/home/advantages";
import { backers } from "../datas/home/backers";
import { FooterBoxes } from "../datas/home/content";
import { exploreCelestia } from "../datas/home/explore-celestia";
import { socialChannels } from "../datas/home/social-channels";

import Card from "../components/modules/card";
import HeroSection from "../components/sections/hero-section";
import BackersSection from "../components/sections/backers-sections";
import SignUp from "../components/modals/signUp";
import Image from "../components/imageComponent";
import CommunityItem from "../components/modules/community-item";

import { seoContent } from "../datas/home/seoContent";
import Seo from "../components/seo";
import HomeHeroSection from "../components/sections/home-hero-section";
import TwoColumn from "../components/sections/two-column";

import scaleImage from "../images/scale.png";
import TwoColumnH2 from "../components/sections/two-column-h2";

import comparisonImage from "../images/comparison.png";

import screen_eth_5 from "../images/screen_eth_5.png";
import screen_teach from "../images/screen_teach.png";
import screen_earn from "../images/screen_earn.png";
import screen_chart_5 from "../images/screen_chart_5.png";
import screen_binary_5 from "../images/screen_binary_5.png";
import screen_lock_5 from "../images/screen_lock_5.png";
import zealy_logo from "../images/zealy_logo.png";
import bot204 from "../images/bot204.jpeg";
import bot208 from "../images/bot208.jpeg";
import roadmap_item_complete0 from "../images/roadmap_item_complete0.png";
import roadmap_item_complete from "../images/roadmap_item_complete.png";
import roadmap_item_complete2 from "../images/roadmap_item_complete2.png";
import roadmap_item_in_progress from "../images/roadmap_item_in_progress.png";
import roadmap_item_in_progress2 from "../images/roadmap_item_in_progress2.png";
import roadmap_item_in_progress3 from "../images/roadmap_item_in_progress3.png";
import roadmap_item_in_progress4 from "../images/roadmap_item_in_progress4.png";
import roadmap_item_in_progress_50 from "../images/roadmap_item_in_progress_50.png";
import roadmap_item_in_progress5 from "../images/roadmap_item_in_progress5.png";
import roadmap_item_todo from "../images/roadmap_item_todo.png";
import roadmap_item_todo1 from "../images/roadmap_item_todo1.png";
import tokenomics_quick from "../images/tokenomics_quick.png";

//imageEle={screen_binary_5}
//imageEle={screen_lock_5}
//imageEle={screen_chart_5}

const IndexPage = () => {
	const [isModalOpen, setIsModalOpen] = useState(false);
	const [modalType] = useState("");
	const enableBackers = false;

	// const handleModalOpen = (event) => {
	// 	setModalType(event.target.id);
	// 	setIsModalOpen(true);
	// 	document.body.style.overflow = "hidden";
	// };

	const handleModalClose = (event) => {
		setIsModalOpen(false);
		document.body.style.overflow = "unset";
	};

	const twitterLink = (
		<a href="https://twitter.com/BoomBotsXyz" className="community-icon" aria-label="Twitter" target="_blank">
			<svg className="w-8 h-8 fill-current" width="100" height="100" viewBox="8 8 16 16" xmlns="http://www.w3.org/2000/svg" style={{display:"inline", width:"100px", height:"100px"}}>
				<path d="M24 11.5c-.6.3-1.2.4-1.9.5.7-.4 1.2-1 1.4-1.8-.6.4-1.3.6-2.1.8-.6-.6-1.5-1-2.4-1-1.7 0-3.2 1.5-3.2 3.3 0 .3 0 .5.1.7-2.7-.1-5.2-1.4-6.8-3.4-.3.5-.4 1-.4 1.7 0 1.1.6 2.1 1.5 2.7-.5 0-1-.2-1.5-.4 0 1.6 1.1 2.9 2.6 3.2-.3.1-.6.1-.9.1-.2 0-.4 0-.6-.1.4 1.3 1.6 2.3 3.1 2.3-1.1.9-2.5 1.4-4.1 1.4H8c1.5.9 3.2 1.5 5 1.5 6 0 9.3-5 9.3-9.3v-.4c.7-.5 1.3-1.1 1.7-1.8z" />
			</svg>
		</a>
	)
	//<div className="community-icon-spacer"/>

	const discordLink = (
		<a href="https://discord.com/invite/dmSFJGqeK2" className="community-icon" aria-label="Discord" target="_blank">
			<svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" fill="currentColor" className="bi bi-discord" viewBox="0 0 16 16" style={{display:"inline"}}>
				<path d="M13.545 2.907a13.227 13.227 0 0 0-3.257-1.011.05.05 0 0 0-.052.025c-.141.25-.297.577-.406.833a12.19 12.19 0 0 0-3.658 0 8.258 8.258 0 0 0-.412-.833.051.051 0 0 0-.052-.025c-1.125.194-2.22.534-3.257 1.011a.041.041 0 0 0-.021.018C.356 6.024-.213 9.047.066 12.032c.001.014.01.028.021.037a13.276 13.276 0 0 0 3.995 2.02.05.05 0 0 0 .056-.019c.308-.42.582-.863.818-1.329a.05.05 0 0 0-.01-.059.051.051 0 0 0-.018-.011 8.875 8.875 0 0 1-1.248-.595.05.05 0 0 1-.02-.066.051.051 0 0 1 .015-.019c.084-.063.168-.129.248-.195a.05.05 0 0 1 .051-.007c2.619 1.196 5.454 1.196 8.041 0a.052.052 0 0 1 .053.007c.08.066.164.132.248.195a.051.051 0 0 1-.004.085 8.254 8.254 0 0 1-1.249.594.05.05 0 0 0-.03.03.052.052 0 0 0 .003.041c.24.465.515.909.817 1.329a.05.05 0 0 0 .056.019 13.235 13.235 0 0 0 4.001-2.02.049.049 0 0 0 .021-.037c.334-3.451-.559-6.449-2.366-9.106a.034.034 0 0 0-.02-.019Zm-8.198 7.307c-.789 0-1.438-.724-1.438-1.612 0-.889.637-1.613 1.438-1.613.807 0 1.45.73 1.438 1.613 0 .888-.637 1.612-1.438 1.612Zm5.316 0c-.788 0-1.438-.724-1.438-1.612 0-.889.637-1.613 1.438-1.613.807 0 1.451.73 1.438 1.613 0 .888-.631 1.612-1.438 1.612Z"/>
			</svg>
		</a>
	)
	//<div className="community-icon-spacer"/>
	//<div className="community-icon-spacer2"/>

	const telegramLink = (
		<a href="https://t.me/BoomBotsXyz" className="community-icon" aria-label="Telegram" target="_blank">
			<svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" fill="currentColor" className="bi bi-discord" viewBox="0 0 240 240">
				<path d="M222.51 19.53c-2.674.083-5.354.78-7.783 1.872-4.433 1.702-51.103 19.78-97.79 37.834C93.576 68.27 70.25 77.28 52.292 84.2 34.333 91.12 21.27 96.114 19.98 96.565c-4.28 1.502-10.448 3.905-14.582 8.76-2.066 2.428-3.617 6.794-1.804 10.53 1.812 3.74 5.303 5.804 10.244 7.69l.152.058.156.048c17.998 5.55 45.162 14.065 48.823 15.213.95 3.134 12.412 40.865 18.65 61.285 1.602 4.226 6.357 7.058 10.773 6.46.794.027 2.264.014 3.898-.378 2.383-.57 5.454-1.924 8.374-4.667l.002-.002c4.153-3.9 18.925-18.373 23.332-22.693l48.27 35.643.18.11s4.368 2.894 10.134 3.284c2.883.195 6.406-.33 9.455-2.556 3.05-2.228 5.25-5.91 6.352-10.71 3.764-16.395 29.428-138.487 33.83-158.837 2.742-10.348 1.442-18.38-3.7-22.872-2.59-2.26-5.675-3.275-8.827-3.395-.394-.015-.788-.016-1.183-.004zm.545 10.02c1.254.02 2.26.365 2.886.91 1.252 1.093 2.878 4.386.574 12.944-12.437 55.246-23.276 111.71-33.87 158.994-.73 3.168-1.752 4.323-2.505 4.873-.754.552-1.613.744-2.884.658-2.487-.17-5.36-1.72-5.488-1.79l-78.207-57.745c7.685-7.266 59.17-55.912 87.352-81.63 3.064-2.95.584-8.278-3.53-8.214-5.294 1.07-9.64 4.85-14.437 7.212-34.79 20.36-100.58 60.213-106.402 63.742-3.04-.954-30.89-9.686-49.197-15.332-2.925-1.128-3.962-2.02-4.344-2.36.007-.01.002.004.01-.005 1.362-1.6 6.97-4.646 10.277-5.807 2.503-.878 14.633-5.544 32.6-12.467 17.965-6.922 41.294-15.938 64.653-24.97 32.706-12.647 65.46-25.32 98.137-37.98 1.617-.75 3.12-1.052 4.375-1.032zM100.293 158.41l19.555 14.44c-5.433 5.32-18.327 17.937-21.924 21.322l2.37-35.762z" color="#000"/>
			</svg>
		</a>
	)
	//<div className="community-icon-spacer"/>

	const zealyLink = (
		<a href="https://zealy.boombots.xyz" className="community-icon" aria-label="Zealy" target="_blank">
			<svg width="84" height="84" viewBox="0 0 84 84" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path fillRule="evenodd" clipRule="evenodd" d="M5.37693 9.24204L2.21093 9.07439L2.19659 12.2718L2.19499 12.9383C2.19404 13.4575 2.19278 14.3538 2.19152 15.8639C2.189 18.8839 2.18648 24.3606 2.18648 34.1883V35.4507L5.93775 39.234C4.45243 40.1765 2.96008 41.1081 1.46088 42.0289L0.0117395 42.919L0 63.9962L17.303 81.4581L18.4389 81.533C39.6703 82.9317 61.5054 81.3798 81.9636 74.2615L84 73.553V48.2255L79.5741 43.7618C80.3282 43.011 81.0806 42.2538 81.8275 41.492L82.7005 40.6015V39.3491C82.7005 38.4847 82.7031 33.9577 82.7056 29.6449L82.7114 19.974L64.8894 2L63.1155 2.59932C44.6964 8.82238 24.941 10.278 5.37693 9.24204ZM64.0755 5.48918L79.6887 21.2356C79.6887 21.2356 79.6786 37.6178 79.6786 39.3491C78.9365 40.1061 78.1881 40.8592 77.4372 41.6067C76.7181 42.3225 75.9966 43.0331 75.2759 43.737L80.9781 49.4879V71.3804C61.0119 78.3276 39.6051 79.8732 18.6359 78.4917L3.02263 62.7351L3.03271 44.6319C4.74009 43.5832 6.43886 42.5206 8.12874 41.4436C9.00082 40.8879 9.87053 40.3283 10.7378 39.7649L5.2084 34.1883C5.2084 23.7569 5.21124 18.2286 5.21391 15.3372C5.21627 12.7806 5.21849 12.2855 5.21849 12.2855C6.22478 12.3388 7.23201 12.3856 8.23997 12.4256C27.065 13.1728 46.1422 11.5481 64.0755 5.48918Z"/>
				<path fillRule="evenodd" clipRule="evenodd" d="M5.21844 12.2855C25.0188 13.334 45.1819 11.8725 64.0754 5.48917L79.6887 21.2356C79.6887 21.2356 79.6786 37.6178 79.6786 39.3491C78.2256 40.8311 76.749 42.2981 75.2759 43.737L80.978 49.4879V71.3804C61.0119 78.3275 39.605 79.8732 18.6358 78.4917L3.02258 62.7351L3.03267 44.6319C5.62116 43.042 8.18985 41.4201 10.7378 39.7649L5.20836 34.1883C5.20836 14.5337 5.21844 12.2855 5.21844 12.2855Z" fill="#0D0D0D"/>
				<path d="M73.6348 29.2004V37.9777C63.8941 47.3443 54.1534 55.5121 44.4229 62.7961C54.5967 62.1155 64.7603 60.4799 74.9442 57.5135C74.9442 60.7542 74.9442 63.9848 74.9442 67.2255C60.9023 71.3297 46.8706 72.8841 32.8388 72.8841C30.1191 72.8841 27.3994 72.8231 24.6797 72.7113V63.9339C34.4203 57.6861 44.161 50.7882 53.8916 42.8947C46.8908 43.7988 39.8899 44.1849 32.8891 44.1849C30.8745 44.1849 28.87 44.1544 26.8554 44.0934C26.8554 40.8527 26.8554 37.6221 26.8554 34.3814C28.8498 34.4424 30.8343 34.4728 32.8288 34.4728C46.4274 34.4728 60.026 33.0201 73.6247 29.1902L73.6348 29.2004Z"/>
			</svg>
		</a>
	)

	const RoadmapItem = (props) => {
		var status = props.status || ""
		var text = props.text || ""
		var imgsrc = {
			"complete": roadmap_item_complete0,
			"in_progress_25": roadmap_item_in_progress4,
			"in_progress_50": roadmap_item_in_progress_50,
			"in_progress_75": roadmap_item_in_progress4,
			"todo": roadmap_item_todo1,
		}[status] || roadmap_item_todo1
		return (
			<center className="roadmap_item">
				<div>
					<img src={imgsrc} alt="status icon"/>
					<span><p>{text}</p></span>
				</div>
			</center>
		)
	}

	return (
		<Layout footerBoxes={FooterBoxes}>
			<Seo title={seoContent.title} description={seoContent.description} ogTitle={seoContent.ogTitle} image={seoContent.image} />
			<div id='index-page' className='index-page'>
				<main>
					<HomeHeroSection heroData={heroData} />

					{/* upper container */}
					<div className='container'>
						<TwoColumnH2
							direction={"ltr"}
							title={"Collect Yield"}
							text={`
								<p>Deploy a bot to easily collect native yield from Blast.</p>
								<p>Tokens accrue in your bot and can be withdrawn at any time.</p>
							`}
							image={"bot204.jpeg"}
							imageEle={bot204}
							buttonPrimaryTitle={"Learn Celestia"}
							buttonPrimaryUrl={"/what-is-celestia/"}
							buttonPrimaryClass={"plausible-event-name=Learn_Celestia_Button--Home_Page-Access_Abundance_Section"}
						/>
						<TwoColumnH2
							direction={"rtl"}
							title={"Automate Trades"}
							text={`
								<p>Bots can trade when certain conditions are met.</p>
								<p>Teach your bot to sell when the price spikes or buy when it dips.</p>
							`}
							image={"bot208.jpeg"}
							imageEle={bot208}
							buttonPrimaryTitle={"Build modular"}
							buttonPrimaryUrl={"/developer-portal/"}
							buttonPrimaryClass={"plausible-event-name=Build_Modular_Button--Home_Page-Build_Whatever_Section"}
							buttonSecondaryTitle={"Deploy"}
							buttonSecondaryUrl={"/developer-portal#deploy"}
							buttonSecondaryClass={"plausible-event-name=Deploy_Button--Home_Page-Build_Whatever_Section"}
						/>
						{/*
						<TwoColumnH2
							direction={"ltr"}
							title={"Earn Rewards"}
							text={`
								<p>Get paid dividends for buying and holding BOOM!</p>
								<p>The easiest way to earn.</p>
							`}
							image={"screen_earn.png"}
							imageEle={screen_earn}
							buttonPrimaryTitle={"Learn Celestia"}
							buttonPrimaryUrl={"/what-is-celestia/"}
							buttonPrimaryClass={"plausible-event-name=Learn_Celestia_Button--Home_Page-Access_Abundance_Section"}
						/>
						*/}
					</div>

					<section id='tokenomics_quick' className='tokenomics_quick_section'>
						<center><h2 className='with-decor pb-2'>Earnings</h2></center>
						<center><img src={tokenomics_quick} alt="tokenomics quick"/></center>
					</section>


					{/* tokenomics */}
					<div className='container tokenomics_section'>
						<div>
							<h3>BOOM! Airdrop begins in March</h3>
							<p>Read about our <a href="/tokenomics">tokenomics</a></p>
							<p>Take part in our <a href="https://zealy.boombots.xyz" target="_blank">Zealy campaign</a></p>
						</div>
					</div>

					{/* lower container */}
					{/*<div className='container'>*/}
						{/*
						<TwoColumnH2
							direction={"rtl"}
							title={"Passive Income"}
							text={`
								<p>You don't need to stare at a screen all day to make money. Let your bot do that for you. Define your bot's trading strategy and walk away. Come back later and check your profits.</p>
								<p>What will you do with that extra time and money?</p>
							`}
							image={"screen_chart_5.png"}
							imageEle={screen_chart_5}
							buttonPrimaryTitle={"Learn Celestia"}
							buttonPrimaryUrl={"/what-is-celestia/"}
							buttonPrimaryClass={"plausible-event-name=Learn_Celestia_Button--Home_Page-Access_Abundance_Section"}
						/>
						<TwoColumnH2
							direction={"ltr"}
							title={"No Coding Required"}
							text={`
								<p>Each bot comes fully equipped with all the code it needs to execute your trading strategy. Use our simple interface to set your parameters and deploy your bot onchain.</p>
								<p>Deploy a bot in minutes, not months.</p>
							`}
							image={"screen_binary_5.png"}
							imageEle={screen_binary_5}
							buttonPrimaryTitle={"Build modular"}
							buttonPrimaryUrl={"/developer-portal/"}
							buttonPrimaryClass={"plausible-event-name=Build_Modular_Button--Home_Page-Build_Whatever_Section"}
							buttonSecondaryTitle={"Deploy"}
							buttonSecondaryUrl={"/developer-portal#deploy"}
							buttonSecondaryClass={"plausible-event-name=Deploy_Button--Home_Page-Build_Whatever_Section"}
						/>
						<TwoColumnH2
							direction={"rtl"}
							title={"Your Bot, Your Coins"}
							text={`
								<p>Backed by the security of the blockchain and smart contracts.</p>
								<p>Your tokens are stored securely in your bot. Only you and the bot can access them. Rest easy with no custodial risk.</p>
							`}
							image={"screen_lock_5.png"}
							imageEle={screen_lock_5}
							buttonPrimaryTitle={"Learn Celestia"}
							buttonPrimaryUrl={"/what-is-celestia/"}
							buttonPrimaryClass={"plausible-event-name=Learn_Celestia_Button--Home_Page-Access_Abundance_Section"}
						/>
						*/}

						{/* team */}
						{/*
						<section id='roadmap' className='join-the-community'>
							<h2 className='with-decor pb-2'>Join the Community</h2>
							<div className='subtitle'>Stay up to date with the latest BOOM! developments</div>
						</section>
						*/}
						{/* roadmap */}

						<section id='roadmap' className='roadmap_section'>
							<center><h2 className='with-decor pb-2'>Roadmap</h2></center>
							{/*<center><h4 className='with-decor pb-2'>Q1 2024</h4></center>*/}
							<div className="spacer"/>
							<RoadmapItem text="Protocol conceptualization" status="complete"/>
							<RoadmapItem text="Blast chosen as supporting chain" status="complete"/>
							<RoadmapItem text="Develop the bot NFT, smart contract account, and first modules" status="complete"/>
							<RoadmapItem text="Deploy on Blast Testnet" status="complete"/>
							<RoadmapItem text="Develop the account abstraction wallet" status="in_progress_50"/>
							<RoadmapItem text="Build the BOOM! token and dividends system" status="in_progress_25"/>
							<RoadmapItem text="Public sale" status="todo"/>
							<RoadmapItem text="Zealy campaign and airdrop" status="todo"/>
							<RoadmapItem text="Develop and release more trading modules" status="todo"/>
							<RoadmapItem text="Introduce protocol rewards and trading competition" status="todo"/>>
							{/*
								<RoadmapItem text="Expand multichain" status="todo"/>
							<center><h4 className='with-decor pb-2'>Q2 2024</h4></center>
							<RoadmapItem text="lets see how long we can make this text before it breaks and we end up with two lines" status="in_progress"/>
							<RoadmapItem text="unknown status" status="aa"/>
							*/}
						</section>

						<div className='container'>
						{/* community */}
						<section id='community' className='join-the-community'>
							<center><h2 className='with-decor pb-2'>Join the Community</h2></center>
							<center><div className='subtitle'>Stay up to date with the latest BOOM! developments</div></center>

							<div style={{"display":"flex","justifyContent":"center","alignItems":"center"}}>
								{twitterLink}
								<div className="community-icon-spacer"/>
								{discordLink}
								<div className="community-icon-spacer"/>
								{telegramLink}
								<div className="community-icon-spacer"/>
								{zealyLink}
							</div>

						</section>
					</div>
					{/*<BackersSection enableBackers={enableBackers} backers={backers} />*/}
				</main>
				<ReactModal isOpen={isModalOpen}>
					<div className='inner'>
						<SignUp modalType={modalType} />
						<button className='close-button' onClick={handleModalClose}>
							<i className='icon-close' aria-label='close' />
						</button>
					</div>
				</ReactModal>
			</div>
		</Layout>
	);
};

export default IndexPage;
